if (!customElements.get('product-carousel')) {
  class SliderCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.product-carousel__slides');
      this.sliderItems = this.querySelectorAll('.product-carousel__slide');
      this.enableSliderLooping = false;
      this.prevButton = this.querySelector('[js-product-carousel="arrow-left"]');
      this.nextButton = this.querySelector('[js-product-carousel="arrow-right"]');

      if (!this.slider || !this.nextButton) return;

      this.initPages();
      const resizeObserver = new ResizeObserver((entries) => this.initPages());
      resizeObserver.observe(this.slider);
    }

    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (element) => element.clientWidth > 0
      );
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset =
        this.sliderItemsToShow[1].offsetLeft -
        this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor(
        (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
          this.sliderItemOffset
      );
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    }

    resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.initPages();
    }

    connectedCallback() {
      this.prevButton?.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton?.addEventListener('click', this.onButtonClick.bind(this));
    }

    update() {
      // Temporarily prevents unneeded updates resulting from variant changes
      // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
      if (!this.slider || !this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage =
        Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPage != previousPage) {
        this.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          })
        );
      }

      if (this.enableSliderLooping) return;

      if (
        this.isSlideVisible(this.sliderItemsToShow[0]) &&
        this.slider.scrollLeft === 0
      ) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (
        this.isSlideVisible(
          this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
        )
      ) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }

    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide =
        this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (
        element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
        element.offsetLeft >= this.slider.scrollLeft
      );
    }

    onButtonClick(event) {
      event.preventDefault();
      const target = event.currentTarget || event.target;
      const step = target.dataset.step || 1;
      this.slideScrollPosition =
        target.name === 'next'
          ? this.slider.scrollLeft + step * this.sliderItemOffset
          : this.slider.scrollLeft - step * this.sliderItemOffset;
      this.slider.scrollTo({
        left: this.slideScrollPosition,
        behavior: 'smooth',
      });

      setTimeout(() => {
        this.update();
      }, 1000);
    }
  }
  customElements.define('product-carousel', SliderCarousel);
}
